import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAdmin = false
}) => {
  const { isAuthenticated, user, ingestToken, refreshAuth } = useAuth();
  const location = useLocation();
  const [bootstrapping, setBootstrapping] = useState(true);

  // Early token ingestion if present on any protected route access
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tokenParam = params.get('token');
    if (tokenParam) {
      ingestToken(tokenParam);
      // Clean URL so token not left in history
      const newUrl = window.location.pathname + window.location.hash;
      window.history.replaceState({}, document.title, newUrl || '/');
      // Refresh auth state (ingestToken already sets state, but explicit for clarity)
      refreshAuth();
    }
    // Small timeout to allow context update before evaluating redirect
    const t = setTimeout(() => setBootstrapping(false), 150);
    return () => clearTimeout(t);
  }, [location.key, ingestToken, refreshAuth]);

  if (bootstrapping) {
    return null; // or a spinner
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireAdmin && user?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
